import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { AbilityLevelsQuery as AbilityLevelsQueryType } from "./__generated__/AbilityLevelsQuery";

const AbilityLevelsQuery = loader("./AbilityLevelsQuery.gql");

type AbilityLevelsQueryProviderType = (props: {
  children: (data: AbilityLevelsQueryType) => ReactNode;
}) => ReactElement;

export const AbilityLevelsQueryProvider: AbilityLevelsQueryProviderType = (props) => {
  const { children } = props;

  const { error, loading, data } = useQuery<AbilityLevelsQueryType>(AbilityLevelsQuery, {
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
